import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CreateBookingModal from '../OwnerModals/CreateBookingModal';
import UpdateBookingModal from '../OwnerModals/UpdateBookingModal';
import BookingsTable from './components/BookingsTable';

// Disable Fast Refresh for this component
if (module.hot) {
  module.hot.decline();
}



// Debug the import
console.log('=== DEBUG IMPORT ===');
//console.log('CreateBookingModal:', CreateBookingModal);
//console.log('CreateBookingModal type:', typeof CreateBookingModal);
//console.log('CreateBookingModal constructor:', CreateBookingModal?.constructor?.name);
//console.log('Is function:', typeof CreateBookingModal === 'function');
console.log('====================');

const BookingsTab = ({
  userGroup,
  userId,
  bookings,
  apartments,
  guests,
  deleteBooking,
  createOrUpdateBooking,
  fetchOwnerBookings,
  error
}) => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [isOwnerCreateModalOpen, setIsOwnerCreateModalOpen] = useState(false);
  const [bookingToUpdate, setBookingToUpdate] = useState(null);
  const [apartmentId, setApartmentId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  // Debug the component render
  console.log('BookingsTab rendering...');

  const handleCreateBooking = () => {
    setApartmentId("");
    setStartDate("");
    setEndDate("");
    setIsModalOpen(true);
  };

  const handleUpdateBooking = (booking) => {
    setBookingToUpdate(booking);
    setIsUpdateModalOpen(true);
  };

  const handleUpdateSaved = () => {
    setIsUpdateModalOpen(false);
    setBookingToUpdate(null);
  };

  const handleOwnerCreateSaved = () => {
    setIsOwnerCreateModalOpen(false);
    // Refresh the owner's booking list
    if (fetchOwnerBookings && userId) {
      fetchOwnerBookings(userId);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const bookingData = {
      guest: userId,
      apartment: parseInt(apartmentId, 10),
      start_date: startDate,
      end_date: endDate,
    };

    await createOrUpdateBooking(bookingData, false);
    setIsModalOpen(false);
  };

  return (
    <div className="w-full">
      {/* Add Booking Button (owners) */}
      {userGroup === "Owners" && (
        <div className="mb-6">
          <button
            onClick={() => setIsOwnerCreateModalOpen(true)}
            className="bg-green-600 text-white px-4 py-2 rounded-md hover:bg-green-700 transition duration-200"
          >
            {t("create_booking") || "Add Booking"}
          </button>
        </div>
      )}

      {/* Create Booking Button (only for guests) */}
      {userGroup === "Guests" && (
        <div className="mb-6">
          <button
            onClick={handleCreateBooking}
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition duration-200"
          >
            {t("create_booking")}
          </button>
        </div>
      )}

      {/* Create Booking Modal (guests only) */}
      <CreateBookingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmit}
        apartmentId={apartmentId}
        setApartmentId={setApartmentId}
        startDate={startDate}
        setStartDate={setStartDate}
        endDate={endDate}
        setEndDate={setEndDate}
        apartments={apartments}
        error={error}
      />

      {/* Owner Create Booking Modal */}
      <UpdateBookingModal
        isOpen={isOwnerCreateModalOpen}
        onClose={() => setIsOwnerCreateModalOpen(false)}
        booking={null}
        apartments={apartments}
        guests={guests}
        onSaved={handleOwnerCreateSaved}
        mode="create"
      />

      {/* Update Booking Modal */}
      <UpdateBookingModal
        isOpen={isUpdateModalOpen}
        onClose={() => { setIsUpdateModalOpen(false); setBookingToUpdate(null); }}
        booking={bookingToUpdate}
        apartments={apartments}
        guests={guests}
        onSaved={handleUpdateSaved}
      />

      {/* Bookings Table */}
      <BookingsTable
        bookings={bookings}
        apartments={apartments}
        guests={guests}
        onUpdate={handleUpdateBooking}
        onDelete={deleteBooking}
        showGuestColumn={userGroup === "Owners"}
        error={error}
      />
    </div>
  );
};

export default BookingsTab;